<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md6>
        <jti-expansion-panel panelName="Device Details">
          <v-container fluid class="py-0">
            <v-form v-model="valid" ref="form" lazy-validation>
              <!-- <v-text-field
                v-if="!showName"
                v-model="data.name"
                label="Name"
                :readonly="readonly"
                required
                :rules="rules"
              ></v-text-field>-->
              <v-text-field
                v-model="data.device_serial"
                label="Device Serial"
                :readonly="readonly"
                required
                :rules="rules"
              ></v-text-field>
              <v-text-field
                v-model="data.model"
                label="Model"
                :readonly="readonly"
                required
                :rules="rules"
              ></v-text-field>
              <v-textarea outline v-model="data.remarks" :readonly="readonly" label="Remarks"></v-textarea>
            </v-form>
          </v-container>
        </jti-expansion-panel>
      </v-flex>
      <v-flex md6 v-if="showSoftwareSerial">
        <jti-expansion-panel panelName="Software Serial Selection">
          <v-container fluid class="py-0">
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-select
                v-model="data.software_serial_id"
                :items="softwareSerials"
                label="Software Serial"
                :clearable="!readonlySoftwareSerial"
                :readonly="readonlySoftwareSerial"
              ></v-select>
            </v-form>
          </v-container>
        </jti-expansion-panel>
      </v-flex>
      <v-flex md6 v-if="showVehicle && !data.spare_status">
        <jti-expansion-panel panelName="Store Selection">
          <v-container fluid class="py-0">
            <v-form v-model="valid" ref="form" lazy-validation>
              <!-- <v-select
                v-model="data.vehicle_id"
                :items="vehicles"
                label="Vehicle"
                :clearable="!readonlyVehicle"
                :readonly="readonlyVehicle"
              ></v-select>-->

              <v-autocomplete
                v-model="data.vehicle_id"
                :items="vehicles"
                label="Store Name"
                :readonly="readonlyVehicle"
                :clearable="!readonlyVehicle"
              ></v-autocomplete>
            </v-form>
          </v-container>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    readonly: Boolean,
    projects: Array,
    companies: Array,
    subcompanies: Array,
    showSoftwareSerial: Boolean,
    showVehicle: Boolean,
    readonlySoftwareSerial: Boolean,
    readonlyVehicle: Boolean,
    softwareSerials: Array,
    vehicles: Array
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        name: this.data.name,
        device_serial: this.data.device_serial,
        model: this.data.model,
        remarks: this.data.remarks,
        software_serial_id: this.data.software_serial_id,
        vehicle_id: this.data.vehicle_id
      };
    }
  },
  data() {
    return {
      valid: true,
      rules: [v => !!v || "This field is required"]
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style></style>
